<template>
  <section>
    <div class="row">
      <h1 class="title">Schedule.</h1>
    </div>
    <div class="row center" style="flex-direction: row;">
      <h2 class="title" style="margin-left: -2.4em; margin-right: 5.6em">Saturday.</h2>
      <h2 class="title">Sunday.</h2>
    </div>
    <div class="row center" style="margin-top: -1em">
      <ul>
        <li>11.00 Opening Ceremony, Team Building</li>
        <li>12.00 Hacking Begins</li>
        <li>13.00 Workshop: Make your tech go further</li>
        <li>14.00 Workshop: GitHub</li>
        <li>15.30 Workshop: An introduction to Tensorflow</li>
        <li>16.30 BlackRock Challenge</li>
        <li>17.00 Workshop: Restful APIs</li>
        <li>19.00 Pictionary</li>
        <li>20.00 MLH Werewolf</li>

        <li>22.00 Quiz</li>
      </ul>
      <ul>
        <li>02.00 Among Us </li>
        <li>08.00 Casual Chat</li>
        <li>11.30 Submissions End</li>
        <li>15.30 Closing Ceremony</li>
        <li>16.30 Event ends</li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
section
  display: flex
  flex-wrap: wrap
  min-width: 96%
  padding: 1.5em 2em
  flex-direction: column
  justify-content: left
  color: #FF3232

.row
  padding: .5em 1.5em
  margin: .5em .75em
  display: flex
  flex: 1 1 auto
  h1
    padding: 0
    color: #FF3232
    font-size: 3.5em
    font-weight: 500
    margin: 0 0 5px 0

h2
  color: #FF3232
  font-weight: 500
  margin: 0 0 5px 0
  padding: 0

ul
  display: block

.center
  justify-content: center

.logo
  display: flex
  align-items:  center
  padding: 0 1.5em

img
  width: 42vw
  max-height: 70px
  min-width: 200px
  max-width: 400px

.button
  font-size: 1.1rem
  // font-size: 20px
</style>



// WEBPACK FOOTER //
// components/Schedule.vue